// var lastScroll = 0;
// const handleScrollResize = () => {
//   let scrollCount = window.pageYOffset;
//   let header = document.querySelector('.shopify-section-header');
//   header.classList.add('solid_header');
//   if (scrollCount === 0) {
//     header.classList.remove('solid_header');
//   }
//   if (scrollCount > header.offsetTop) {
//     header.classList.add('sticky_header');
//   }
//   if (scrollCount < document.querySelector('.shopify-section-announcement-bar').clientHeight &&
//       document.body.classList.contains('scroll-up')) {
//     header.classList.remove('sticky_header');
//   }
//   setTimeout(() => {
//     if (scrollCount > lastScroll) {
//       document.body.classList.remove('scroll-up');
//       document.body.classList.add('scroll-down');
//     } else if (scrollCount < lastScroll) {
//       document.body.classList.remove('scroll-down');
//       document.body.classList.add('scroll-up');
//     }
//     lastScroll = scrollCount;
//   }, 0);
// };
// window.addEventListener('scroll', handleScrollResize);
// window.addEventListener('resize', handleScrollResize);
// document.addEventListener('DOMContentLoaded', handleScrollResize);
var lastScroll = 0;
// const handleScrollResize = () => {
//   let scrollCount = window.pageYOffset;
//   let header = document.querySelector('.shopify-section-header');
//   let announcementBar = document.querySelector('.shopify-section-announcement-bar');
//   let isHome = document.body.classList.contains('template-index');
//   if (!header) return;
//   if (scrollCount > header.offsetTop - 40) {
//     header.classList.add('sticky_header');
//   } else if (scrollCount < header.offsetTop + 40) {
//     header.classList.remove('sticky_header');
//   }
const handleScrollResize = () => {
  let scrollCount = window.pageYOffset;
  let header = document.querySelector('.shopify-section-header');
  let announcementBar = document.querySelector('.shopify-section-announcement-bar');
  let isHome = document.body.classList.contains('template-index');
  if (!header) return;
  if (scrollCount > header.offsetTop) {
    header.classList.add('sticky_header');
  } else {
    header.classList.remove('sticky_header');
  }
  if (isHome) {
    let secondSection = document.querySelector('main .shopify-section:nth-child(2)');
    if (secondSection) {
      let secondSectionTop = secondSection.getBoundingClientRect().top;
      if (secondSectionTop <= 0) {
        header.classList.add('solid_header');
      } else {
        header.classList.remove('solid_header');
      }
    }
  } else {
    header.classList.add('solid_header');
    if (scrollCount === 0) {
      header.classList.remove('solid_header');
    }
    if (
      scrollCount < announcementBar?.clientHeight &&
      document.body.classList.contains('scroll-up')
    ) {
      header.classList.remove('sticky_header');
    }
  }
  setTimeout(() => {
    if (scrollCount > lastScroll) {
      document.body.classList.remove('scroll-up');
      document.body.classList.add('scroll-down');
    } else if (scrollCount < lastScroll) {
      document.body.classList.remove('scroll-down');
      document.body.classList.add('scroll-up');
    }
    lastScroll = scrollCount;
  }, 0);
};
window.addEventListener('scroll', handleScrollResize);
window.addEventListener('resize', handleScrollResize);
document.addEventListener('DOMContentLoaded', handleScrollResize);
document.addEventListener("DOMContentLoaded", (event) => {
  let scrollCount = window.pageYOffset;
  let header = document.querySelector('.shopify-section-header');
  header.classList.add('solid_header');
  if(scrollCount == 0){
    header.classList.remove('solid_header');
  }
  if(scrollCount > header.offsetTop){
    header.classList.add('sticky_header');
  }
});
function productcarousel() {
  var productslider = [];
  if (document.querySelectorAll('.mega-blk-slider.swiper')) {
    document.querySelectorAll('.mega-blk-slider.swiper').forEach(function (Element, index) {
      let productid = Element.dataset.id;
      let progress = Element.closest('.mega-block').querySelector('.swiper-scrollbar');
      let swiperObject = {
        loop: false,
        slidesPerView: "auto",
        freeMode: {
          enabled: true,
          sticky: false,
          momentum: true,
          momentumRatio: 1,
          momentumVelocityRatio: 1,
        },
        scrollbar: {
          el: progress,
          draggable: true,
          hide: false,
        },
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
        },
      };
      productslider[productid] = new Swiper(Element, swiperObject);
    });
  }
}
productcarousel();
function setDrawerPosition(){
  if(window.innerWidth > 991) return;
  let header = document.querySelector('.shopify-section-header');
  let announce = document.querySelector('.shopify-section-announcement-bar');
  const countdown = document.querySelector('.section-countdown-bar');
  let headerHeight = header ? header.offsetHeight : 0;
  let announceHeight = 0;
  if(announce){
    const rect = announce.getBoundingClientRect();
    if(rect.bottom > 0) announceHeight = Math.min(rect.height, rect.bottom);
  }
  let countdownHeight = 0;
  if (countdown && !countdown.classList.contains('hidden')) {
    const rect = countdown.getBoundingClientRect();
    if (rect.bottom > 0) countdownHeight = Math.min(rect.height, rect.bottom);
  }
  const drawerTop = headerHeight + announceHeight + countdownHeight - 1;
  let drawer = document.querySelector('.snippet-menu-drawer');
  if(drawer){
    drawer.style.top = drawerTop + 'px';
    drawer.style.height = 'calc(100% - ' + drawerTop + 'px)';
  }
}
if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger) {
  menuBurger.addEventListener('click', function(e) {
    document.body.classList.remove('open-search');
    setTimeout(() => {
      setDrawerPosition();
    }, 100);
    setTimeout(() => {
      setDrawerPosition();
      document.body.classList.toggle('open-menu');
      document.body.classList.remove('open-drawer','open-search','open-sort','open-filter');
    }, 100);
  });
});
window.addEventListener('resize', function(){
  if(window.innerWidth > 991){
    document.body.classList.remove('open-menu');
  }else{
    if(document.body.classList.contains('open-menu')) setDrawerPosition();
  }
});
if(document.querySelectorAll('.mobile-search')) document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    const searchreg = document.querySelector("#predictive-search");
      if (searchreg) {
        searchreg.style.display = 'none';
      }
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','search-type');
      setTimeout(function() {
        const searchInput = document.querySelector(".snippet-search-bar #Search");
        if (searchInput) {
          searchInput.focus();
        }
      }, 250);
      setTimeout(function() {
        const searchInput = document.querySelector(".snippet-search-bar #Search");
        if (searchInput) {
          searchInput.value = '';
        }
      }, 50);
  });
});
if(document.querySelector('.overlay-box')) document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});
if(document.querySelectorAll('.mega-sublist > a')) document.querySelectorAll('.mega-sublist > a').forEach(function (menuSublist){
  menuSublist.addEventListener('click', function(e){
    e.preventDefault();
    let parent = menuSublist.closest('.mega-sublist');
    let submenu = parent.querySelector('.md-main-child-menu');
    let isActive = parent.classList.contains('active-sublist');
    document.querySelectorAll('.mega-sublist').forEach(function (item) {
      item.classList.remove('active-sublist');
      let sm = item.querySelector('.md-main-child-menu');
      if(sm) sm.style.maxHeight = null;
    });
    if(!isActive && submenu){
      parent.classList.add('active-sublist');
      submenu.style.maxHeight = submenu.querySelector('ul').scrollHeight + "px";
    }
  });
});
let md_swiper = new Swiper(".md-slider.swiper", {
  slidesPerView: "auto",
  autoHeight: true,
  scrollbar: {
    el: ".snippet-menu-drawer .custom-swiper-scrollbar",
    draggable: true,
  },
});
document.querySelectorAll('.md-head a').forEach(function (md_head) {
  md_head.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelectorAll('.md-head li').forEach(function (li) {
      li.classList.remove('active-menu-tab');
    });
    md_head.closest('li').classList.add('active-menu-tab');
    let val = md_head.closest('li').getAttribute('data-val');
    const slides = document.querySelectorAll('.md-slider .swiper-slide.md-main-nav');
    let targetIndex = Array.from(slides).findIndex(slide => slide.getAttribute('data-val') === val);
    md_swiper.slideTo(targetIndex);
  });
});
var swiper = new Swiper(".search_recommended_slider.swiper", {
  slidesPerView: "auto",
  spaceBetween: 1,
  scrollbar: {
      el: ".search_recommended_wrap .swiper-scrollbar",
      draggable: true,
    },
    grabCursor: true,
  // pagination: {
  //   el: ".swiper-pagination",
  //   type: "progressbar",
  // },
  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true,
  },
  on: {
    scrollbarDragStart() {
      document.body.classList.add('dragging');
    },
    scrollbarDragEnd() {
      document.body.classList.remove('dragging');
    }
  }
});